import { render, staticRenderFns } from "./skTabMine.vue?vue&type=template&id=67dcc4e2&scoped=true"
import script from "./skTabMine.vue?vue&type=script&lang=js"
export * from "./skTabMine.vue?vue&type=script&lang=js"
import style0 from "./skTabMine.vue?vue&type=style&index=0&id=67dcc4e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dcc4e2",
  null
  
)

export default component.exports